module.exports = __webpack_public_path__ + "img/thumb_35.c13c30c2.jpg";